// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.5 2.71741L2 5.92575V21.5001L7.5 19.2328V2.71741Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.5 18.9097L11.5 20.0908V16.5C11.5 14.1988 12.6958 12.1769 14.5 11.0218V5.09051L9.5 2.1377V18.9097Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 2.50012V11.3762C20.897 10.5139 19.5085 10 18 10C17.4837 10 16.9815 10.0602 16.5 10.1739V4.76744L22 2.50012Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16.75 15.25C16.75 14.5596 17.3096 14 18 14C18.3441 14 18.6541 14.1377 18.8811 14.3634L19.5904 15.0683L21.0003 13.6498L20.291 12.9448C19.7045 12.3619 18.8936 12 18 12C16.2051 12 14.75 13.4551 14.75 15.25V16H13.499V22.5H22.499V16H16.75V15.25Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-map-unlocked-filled')
export default class MapUnlockedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-unlocked-filled',
    }
  }
}
